import qs from 'qs';

export const STRAPI_BASE_URL: string | undefined = process.env.REACT_APP_STRAPI_ENDPOINT || 'http://localhost:1337';
export const STRAPI_CDN_URL: string | undefined = process.env.REACT_APP_CDN_URL || 'http://localhost:1337/uploads';

export async function getImagenesInicio() {
  try {
    const queryParams = {
      fields: ['nombre', 'texto_destacado', 'descripcion'],
      populate: {
        imagen: {
          fields: ['url']
        }
      },
      sort: ['createdAt:ASC']
    };

    const response = await fetch(`${STRAPI_BASE_URL}/api/imagenes-inicios?${qs.stringify(queryParams)}`);
    const data = await response.json();
    return data.data;
  }
  catch (error) {
    console.error('Error buscando imagenes inicio:', error);
    return null;
  }
}

export async function getSolucionesEnergeticas(params: { visible?: boolean } = {}) {
  try {
    const queryParams = {
      fields: ['nombre', 'url', 'externo'],
      filters: {
        ...(params.visible !== undefined ? { visible: { $eq: params.visible } } : {}),
      },
      populate: {
        portada: {
          fields: ['url']
        },
        imagen_industria: {
          fields: ['url']
        }
      },
      sort: ['createdAt:ASC']
    };
    
    const response = await fetch(`${STRAPI_BASE_URL}/api/solucion-energeticas?${qs.stringify(queryParams)}`);
    const data = await response.json();
    return data.data;
  }
  catch (error) {
    console.error('Error buscando soluciones energeticas:', error);
    return null;
  }
}

export async function getSolucion(slug: string): Promise<any> {
  try {
    const queryParams = {
      fields: ['beneficios', 'descripcion', 'nombre', 'url'],
      filters: {
        url: {
          $eq: slug
        }
      },
      populate: {
        banner: {
          fields: ['url']
        },
        icono: {
          fields: ['url']
        },
        imagen_beneficios: {
          fields: ['url']
        },
        imagen_industria: {
          fields: ['url']
        },
        imagen_proyectos: {
          fields: ['url']
        },
        portada: {
          fields: ['url']
        },
        caracteristicas: {
          on: {
            'shared.caracteristica': {
              fields: ['contenido'],
              populate: {
                imagen: { fields: ['url'] }
              }
            }
          }
        }
      }
    };

    const response = await fetch(`${STRAPI_BASE_URL}/api/solucion-energeticas?${qs.stringify(queryParams)}`);
    const data = await response.json();
    return data.data.length > 0 ? data.data[0] : null;
  }
  catch (error) {
    console.error('Error buscando solucion por slug:', error);
    return null;
  }
}

export async function getIndustrias(): Promise<any[]> {
  try {
    const queryParams = {
      populate: {
        logo: {
          fields: ['url']
        },
        icono: {
          fields: ['url']
        },
        soluciones_energeticas: {
          fields: ['nombre', 'url', 'externo'],
        }
      },
      sort: ['createdAt:ASC']
    };
    const response = await fetch(`${STRAPI_BASE_URL}/api/industries?${qs.stringify(queryParams)}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const data = await response.json();
    return data.data as any[];
  }
  catch (error) {
    console.error('Error buscando industrias:', error);
    return [];
  }
}

export async function getIndustriaBySlug(slug: string): Promise<any> {
  try {
    const queryParams = {
      populate: {
        logo: {
          fields: ['url']
        },
        banner: {
          fields: ['url']
        },
        imagen_beneficios: {
          fields: ['url']
        },
        soluciones_energeticas: {
          fields: ['nombre', 'url', 'externo'],
          populate: {
            banner: {
              fields: ['url']
            },
            imagen_industria: {
              fields: ['url']
            }
          }
        },
        experiencia: {
          on: {
            'shared.caracteristica': {
              fields: ['contenido'],
              populate: {
                imagen: { fields: ['url'] }
              }
            }
          }
        }
      },
      filters: {
        slug: {
          $eq: slug
        }
      },
      sort: ['createdAt:ASC']
    }
    
    const response = await fetch(`${STRAPI_BASE_URL}/api/industries?${qs.stringify(queryParams)}`);
    const data = await response.json();
    return data.data.length > 0 ? data.data[0] : null;
  }
  catch (error) {
    console.error('Error buscando industria por slug:', error);
    return null;
  }
}

export async function getCasosExito() {
  try {
    const queryParams = {
      sort: {
        createdAt: 'desc'
      },
      populate: '*'
    }

    const response = await fetch(`${STRAPI_BASE_URL}/api/casos-exitos?${qs.stringify(queryParams)}`);
    const data = await response.json();
    return data.data;
  }
  catch (error) {
    console.error('Error buscando casos de éxito:', error);
    return null;
  }
}

export async function getCasosExitoDestacados() {
  try {
    const queryParams = {
      filters: {
        destacado: {
          $eq: true
        }
      },
      sort: {
        createdAt: 'desc'
      },
      populate: '*'
    }

    const response = await fetch(`${STRAPI_BASE_URL}/api/casos-exitos?${qs.stringify(queryParams)}`);
    const data = await response.json();
    return data.data;
  }
  catch (error) {
    console.error('Error buscando casos de éxito destacados:', error);
    return null;
  }
}

export async function getCasoExito(slug: string) {
  try {
    const response = await fetch(`${STRAPI_BASE_URL}/api/casos-exitos?filters[slug][$eq]=${slug}&pLevel`);
    const data = await response.json();
    return data.data.length > 0 ? data.data[0] : null;
  }
  catch (error) {
    console.error('Error buscando caso de éxito por slug:', error);
    return null;
  }
}

export async function getUltimosCasosExito() {
  const queryParams = {
    sort: {
      createdAt: 'desc'
    },
    pagination: {
      start: 0,
      limit: 4
    },
    populate: '*'
  }

  const response = await fetch(`${STRAPI_BASE_URL}/api/casos-exitos?${qs.stringify(queryParams)}`);
  const data = await response.json();
  return data.data;
}

export async function getArticulos() {
  try {
    const queryParams = {
      sort: {
        createdAt: 'desc'
      },
      populate: '*'
    }

    const response = await fetch(`${STRAPI_BASE_URL}/api/articulos?${qs.stringify(queryParams)}`);
    const data = await response.json();
    return data.data;
  }
  catch (error) {
    console.error('Error buscando artículos:', error);
    return null;
  }
}

export async function getArticuloBySlug(slug: string) {
  try {
    const response = await fetch(`${STRAPI_BASE_URL}/api/articulos?filters[slug][$eq]=${slug}&pLevel`);
    const data = await response.json();
    return data.data.length > 0 ? data.data[0] : null;
  }
  catch (error) {
    console.error('Error buscando artículo por slug:', error);
    return null;
  }
}

// Obtener los últimos 2 artículos excluyendo uno específico por slug
export async function getArticulosPopulares(excludeSlug?: string) {
  try {
    const queryParams: any = {
      sort: {
        createdAt: 'desc'
      },
      pagination: {
        start: 0,
        limit: 2
      },
      populate: '*'
    };

    if (excludeSlug) {
      queryParams.filters = {
        slug: {
          $ne: excludeSlug
        }
      };
    }

    const response = await fetch(`${STRAPI_BASE_URL}/api/articulos?${qs.stringify(queryParams)}`);
    const data = await response.json();
    return data.data;
  }
  catch (error) {
    console.error('Error buscando artículos populares:', error);
    return null;
  }
}

export async function getPodcasts() {
  try {
    const queryParams = {
      sort: {
        createdAt: 'desc'
      },
      populate: '*'
    }

    const response = await fetch(`${STRAPI_BASE_URL}/api/podcasts?${qs.stringify(queryParams)}`);
    const data = await response.json();
    return data.data;
  }
  catch (error) {
    console.error('Error buscando podcasts:', error);
    return null;
  }
}

export async function getPodcastBySlug(slug: string) {
  try {
    const response = await fetch(`${STRAPI_BASE_URL}/api/podcasts?filters[slug][$eq]=${slug}&pLevel`);
    const data = await response.json();
    return data.data.length > 0 ? data.data[0] : null;
  }
  catch (error) {
    console.error('Error buscando podcast por slug:', error);
    return null;
  }
}

// Obtener otros podcasts excluyendo el actual (maximo 5 podcasts)
export async function getOtrosPodcasts(slug: string) {
  try {
    const response = await fetch(`${STRAPI_BASE_URL}/api/podcasts?filters[slug][$ne]=${slug}&pagination[limit]=5&populate=*`);
    const data = await response.json();
    return data.data;
  }
  catch (error) {
    console.error('Error buscando otros podcasts:', error);
    return null;
  }
}

export async function uploadImage(file: File, token: string): Promise<any> {
  const formData = new FormData();
  formData.append('files', file);

  try {
    const response = await fetch(`${STRAPI_BASE_URL}/api/upload`, {
      method: 'POST',
      body: formData,
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });

    if (!response.ok) {
      throw new Error('Error al subir la imagen');
    }

    const data = await response.json();
    return data.length > 0 ? data[0] : null;
  } catch (error) {
    console.error('Error subiendo imagen:', error);
    return null;
  }
}